import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import {
  ArchivioDocumentiListingNode,
  ListingArchivioDocumentiNode,
  PaginaNode,
  useListingArchivioDocumentiLazyQuery,
  useListingComunicatiStampaLazyQuery,
} from '@gql/graphql'
import useTrans from '@hooks/useTrans'
import ArchiviDocumentiTemplate from '@components/templates/ArchiviDocumentiTemplate/ArchiviDocumentiTemplate'

interface BlogListingProps {
  pagina: PaginaNode
  listing: ListingArchivioDocumentiNode
  buttonUrl?: boolean
  comunicati?: boolean
  slug: string
}

const ArchivioDocumentiListing = ({
  pagina,
  listing,
  buttonUrl = false,
  slug,
  comunicati = false,
}: BlogListingProps) => {
  const router = useRouter()
  const [page, setPage] = useState(listing?.paginator?.currentPage)
  const [elementi, setElementi] = useState<ArchivioDocumentiListingNode[]>(listing?.elementi ?? [])
  const [listingArchivioDocumenti, { loading: loadingNews }] = useListingArchivioDocumentiLazyQuery(
    {
      fetchPolicy: 'cache-first',
    }
  )
  const [listingComunicatiSTampa, { loading: loadingComunicatiStampa }] =
    useListingComunicatiStampaLazyQuery({
      fetchPolicy: 'cache-first',
    })

  const nextPageLength = listing?.paginator?.itemsPerPage
  const anni = listing?.anni
  const anno = listing?.anno
  const t = useTrans()

  const powerBarItems =
    anni && Array.isArray(anni) && anni.length > 0
      ? [
          {
            pk: 0,
            name: t('Mostra tutti'),
            selected: !anno,
            url: listing.root
              ? listing?.root?.url.includes('/y/')
                ? listing?.root?.url.replace('/y/', '')
                : listing?.root?.url
              : slug.includes('/y/')
              ? slug.replace('/y/', '')
              : slug,
          },
        ].concat(
          anni.map((x) => ({
            pk: x,
            name: x.toString(),
            selected: parseInt(anno) === x,
            url: listing.root
              ? listing?.root?.url.includes('/y/')
                ? `${listing?.root?.url}/${x}/`
                : `${listing?.root?.url}/y/${x}/`
              : slug.includes('/y/')
              ? `${slug.replace('/y/', '')}${x}/`
              : `${slug}/y/${x}/`,
          })) ?? []
        )
      : []

  const fetchListing = async () => {
    if (comunicati) {
      const { data } = await listingComunicatiSTampa({
        variables: {
          anno: anno,
          params: { p: page },
          slug: slug,
        },
      })

      if (data?.listingComunicatiStampa?.elementi) {
        listing.paginator = data?.listingComunicatiStampa?.paginator
        setElementi([...elementi, ...data.listingComunicatiStampa.elementi])
      }
    } else {
      const { data } = await listingArchivioDocumenti({
        variables: {
          anno: anno,
          params: { p: page },
          slug: slug,
          pageKey: pagina.chiave,
        },
      })
      if (data?.listingArchivioDocumenti?.elementi) {
        listing.paginator = data?.listingArchivioDocumenti?.paginator
        setElementi([...elementi, ...data.listingArchivioDocumenti.elementi])
      }
    }
  }

  useEffect(() => {
    if (page === listing.paginator.currentPage) return
    fetchListing()
  }, [page])

  const handleMore = (event) => {
    event.preventDefault()
    router.replace(`${router.asPath.split('?')[0]}?page=${page + 1}`, undefined, {
      shallow: true,
      scroll: false,
    })
    setPage(page + 1)
  }

  const linkNextPage = listing?.paginator?.pages[listing?.paginator?.currentPage]?.href

  return (
    <ArchiviDocumentiTemplate
      key={`${pagina.slug}-${listing.anno}` || listing.canonicalUrl}
      pagina={pagina}
      documenti={elementi}
      powerBarItems={powerBarItems}
      handleMore={handleMore}
      loading={loadingNews}
      nextPageLength={nextPageLength}
      linkNextPage={linkNextPage}
      buttonUrl={buttonUrl}
    />
  )
}

export default ArchivioDocumentiListing
